module.exports = __webpack_public_path__ + "static/media/brujula-fr.4eb74066.svg";